import { render, staticRenderFns } from "./CustomUlList.vue?vue&type=template&id=d3613a9a&scoped=true"
import script from "./CustomUlList.vue?vue&type=script&lang=js"
export * from "./CustomUlList.vue?vue&type=script&lang=js"
import style0 from "./CustomUlList.vue?vue&type=style&index=0&id=d3613a9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3613a9a",
  null
  
)

export default component.exports